import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { firebaseAnalytics } from '../lib/firebase';

/**
 * Fires a GA4 `page_view` event every time the SPA route changes.
 *
 * Firebase Analytics auto-collects an initial page_view on script init, but
 * single-page apps need to fire subsequent ones manually since the page
 * never actually reloads. This hook subscribes to react-router's location
 * changes and fires page_view with the new path/title.
 *
 * No-ops when VITE_FIREBASE_MEASUREMENT_ID is not configured (staging,
 * local dev), because firebaseAnalytics resolves to null in that case.
 */
export function useAnalytics(): void {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    void firebaseAnalytics.then((analytics) => {
      if (cancelled || !analytics) return;
      logEvent(analytics, 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);
}
